<div class="">
     <table mat-table [dataSource]="dataSource">


          <!-- Weight Column -->
          <ng-container matColumnDef="fecha_venta">
               <th mat-header-cell *matHeaderCellDef> Fecha </th>
               <td mat-cell *matCellDef="let element"> {{element.fecha_venta}} </td>
          </ng-container>

          <ng-container matColumnDef="rut">
               <th mat-header-cell *matHeaderCellDef> RUT </th>
               <td mat-cell *matCellDef="let element"> {{element.rut}} </td>
          </ng-container>

          <ng-container matColumnDef="nombre_cliente">
               <th mat-header-cell *matHeaderCellDef> Nombre </th>
               <td mat-cell *matCellDef="let element"> {{element.nombre_cliente}} </td>
          </ng-container>

          <!-- Symbol Column -->
          <ng-container matColumnDef="plan">
               <th mat-header-cell *matHeaderCellDef> Plan </th>
               <td mat-cell *matCellDef="let element"> {{element.plan}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
     </table>

     <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
     </mat-paginator>
</div>